export default __webpack_public_path__ + "static/media/image.alpha-design.eea4c398.png";